/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAttachmentDeleteResponseData } from './genericApiResponseAttachmentDeleteResponseData';
import type { GenericApiResponseAttachmentDeleteResponseMessage } from './genericApiResponseAttachmentDeleteResponseMessage';
import type { GenericApiResponseAttachmentDeleteResponsePagination } from './genericApiResponseAttachmentDeleteResponsePagination';
import type { GenericApiResponseAttachmentDeleteResponseError } from './genericApiResponseAttachmentDeleteResponseError';

export interface GenericApiResponseAttachmentDeleteResponse {
  data?: GenericApiResponseAttachmentDeleteResponseData;
  message?: GenericApiResponseAttachmentDeleteResponseMessage;
  pagination?: GenericApiResponseAttachmentDeleteResponsePagination;
  error?: GenericApiResponseAttachmentDeleteResponseError;
  statusCode?: number;
}
